import { cn } from 'src/lib/utils';

type Props = {
  className?: string;
};

const ResourceList = ({ children, className }: React.PropsWithChildren<Props>) => {
  return (
    <div className={cn('grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-6 gap-x-4', className)}>{children}</div>
  );
};

export default ResourceList;
